/* eslint-disable prettier/prettier */
/* eslint-disable no-underscore-dangle */
import queryString from 'query-string';
import { QueryParams } from '../interfaces/interfaces';

export const PAGE_COUNT = 10

const createURL = (obj: QueryParams) => {
  return (rout: string): string => {
    let query = {};

    let near;
    if(obj.near) {
      const isPostalCode = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
      if(isPostalCode.test(obj.near)) {
        near = `${obj.near} postal code`;
      } else {
        near = `${obj.near} city`;
      }

      if(obj.radius) {
        near = `${near}||${obj.radius}|km`;
      }
    }

    let sort;
    let score;

    if(obj?._embedding) {
      sort = '_score';
      score = '_embedding';
    }

    if(near) {
      if(rout === '/v1/fhir/PractitionerRole'){
        sort = '_score';
        score = 'location.near';
      } else {
        sort = '_score';
        sort = 'near';
      }
    }

    let country;
    if(obj.country && obj.country !== 'all') {
      country = obj.country;
    }

    let province;
    if(obj.province) {
      province = obj.province.join(',');
    }

    if (rout === '/v1/fhir/PractitionerRole') {
      query = {
        '_embedding': obj?._embedding,
        'role': 'doctor,112247003,224571005',
        '_count': PAGE_COUNT,
        '_include': ['PractitionerRole:practitioner', 'PractitionerRole:location'],
        'specialty': obj?.specialty,
        'practitioner.name:contains': obj?.name?.split(' '),
        'practitioner.gender': obj?.gender,
        'practitioner.communication': obj?.languages,
        'location.address-state': province,
        'location.address-country': country,
        'location.near': near,
        '_sort': sort,
        '_page': obj?.page,
        '_score': score,
      };
    } else {
      query = {
        '_embedding': obj?._embedding,
        '_text': obj.name,
        'type': 'PHARM,MBL',
        '_count': PAGE_COUNT,
        'address-country': country,
        'address-state': province,
        'near': near,
        '_sort': sort,
        '_score': score,
        '_page': obj?.page,
        '_include': ['Location:managing-organization'],
      };
    }

    return queryString.stringifyUrl(
      {
        url: `${process.env.REACT_APP_URL_HOST}${rout}`,
        query,
      },
      {
        skipNull: true,
        skipEmptyString: true,
        arrayFormat: 'bracket',
      }
    );
  };
};

export const createURLForUploadHistory = (routeValue: string, sourceIdValue: string = '') =>
  queryString.stringifyUrl({
    url: `${process.env.REACT_APP_URL_HOST}/admin/v1${routeValue}`,
    query: `${routeValue}` === '/file_types' ? { file_source_id: sourceIdValue } : { file_type_id: sourceIdValue },
  });

export default createURL;
